query JiraIssueByKey($cloudId: ID!, $key: String!) {
  jira {
    issuesByKey(cloudId: $cloudId, keys: [$key]) {
      key
      webUrl
    }
  }
}
